import { render, staticRenderFns } from "./IssueListGroup.vue?vue&type=template&id=05a393ce&scoped=true"
import script from "./IssueListGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueListGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./IssueListGroup.vue?vue&type=style&index=0&id=05a393ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a393ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05a393ce')) {
      api.createRecord('05a393ce', component.options)
    } else {
      api.reload('05a393ce', component.options)
    }
    module.hot.accept("./IssueListGroup.vue?vue&type=template&id=05a393ce&scoped=true", function () {
      api.rerender('05a393ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/revising/IssueListGroup.vue"
export default component.exports